import React, { FC } from "react";

interface RequireLabelIconProps {}

const RequireLabelIcon: FC<RequireLabelIconProps> = (props) => {
  return <span style={{ color: "red", marginLeft: "0.2rem" }}>*</span>;
};

export default RequireLabelIcon;
